
import debounce from 'lodash/debounce'
import 'components/catalog.tag'
import moment from 'moment'
riot.tag2('warehouse-list', '\n  <virtual hide="{loader}">\n\n\n    <div class="col-md-3 hidden-xs hidden-sm">\n      <catalog-tree object="WarehouseBrand" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" descendants="true" deselall="true"></catalog-tree>\n    </div>\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog object="Warehouse" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" disablecolselect="true" combine-filters="true" before-success="{getAggregation}" store="warehouse-list" disablepagination="true" filters="{allFilters}">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group" style="width: 200px;" each="{purchase, i in parent.purchases}">\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="idPurchase" data-sign="in" value="{purchase.id}" checked>&nbsp; {purchase.id} - {purchase.provider}\n                </label>\n              </div>\n            </div>\n          </div>\n        </yield>\n        <yield to="head-right">\n          <div class="form-group pull-right">\n            <div>\n              <label class="text-muted pull-left">\n                 Общее количество упаковок:<strong> {parent.item.totalStock}</strong></label>\n            </div>\n            <div>\n              <label class="text-muted pull-left">\n                 Итого стоимость по закупке:<strong> {parent.item.totalAmountPurchase}</strong></label>\n            </div>\n            <div>\n              <label class="text-muted pull-left">\n                 Итого стоимость по продаже:<strong> {parent.item.totalAmount}</strong></label>\n            </div>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell class="{text-muted: !row.calc}" name="pos"><span class="fa fa-fw select-row-calc {row.calc ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.clk1}"></span>{parent.i + 1}</datatable-cell>\n          <datatable-cell name="article" onclick="{handlers.copyText}">{row.article}</datatable-cell>\n          <datatable-cell name="nameBrand" onclick="{handlers.copyText}">{row.nameBrand}</datatable-cell>\n          <datatable-cell name="name" onclick="{handlers.copyText}" style="width: 50%;">{row.name}</datatable-cell>\n          <datatable-cell name="purchase"><span each="{id, i in row.purchase}"><a class="open-page-item" href="#purchases/{id}" target="_blank">{id}</a>&nbsp;</span></datatable-cell>\n          <datatable-cell name="stock" onclick="{handlers.copyText}" style="max-width: 20px;">{row.stock}</datatable-cell>\n          <datatable-cell name="amountPurchase" onclick="{handlers.copyText}" style="max-width: 20px;">{row.amountPurchase}</datatable-cell>\n          <datatable-cell name="amount" onclick="{handlers.copyText}" style="max-width: 20px;">{row.amount}</datatable-cell>\n        </yield>\n\n      </catalog>\n    </div>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var self = this;

self.item = {};
self.purchases = [];
self.mixin('change');
self.mixin('permissions');
self.allFilters = false;

self.cols = [{ name: '', value: '#' }, { name: 'article', value: 'Артикул' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: '', value: '№ закупки' }, { name: 'stock', value: 'Остаток' }, { name: 'amountPurchase', value: 'Сумма закупки' }, { name: 'amount', value: 'Сумма продажи' }];

self.Filters = function () {
    self.update();
    self.tags.catalog.reload();
};

self.handlers = {
    copyText: function copyText(elem) {
        copyToClipboard(elem.target);
    },
    clk1: function clk1(e) {
        e.stopPropagation();
        console.log(e);
        e.item.row.calc = !e.item.row.calc;
        self.update();
    },
    selectPurchase: function selectPurchase(elem) {
        console.log(elem.target.value);
    }
};

function copyToClipboard(elem) {

    var target = document.createElement("textarea");
    target.style.position = "absolute";
    target.style.left = "-9999px";
    target.style.top = "0";
    document.body.appendChild(target);
    target.value = elem.innerHTML.trim();

    target.focus();
    target.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {}
}

self.getAggregation = function (response, xhr) {
    self.item = response;
};
/*
self.reload = () => {
    self.loader = true
    self.update()

    API.request({
        object: 'Warehouse',
        method: 'Fetch',
        data: {},
        success(response) {
            self.item = response
        },
        complete() {
            self.loader = false
            self.update()
        }
    })
}
*/

self.getPurchases = function () {
    API.request({
        object: 'Purchase',
        method: 'Fetch',
        success: function success(response) {
            self.purchases = response.items;
            self.update();
        }
    });
};

self.on('update', function () {
    if (self.item && self.item.items) {
        self.item.totalAmount = self.item.items.map(function (i) {
            return i.amount * i.calc;
        }).reduce(function (p, c) {
            return p + c;
        }, 0);
    }
});

self.one('updated', function () {
    self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {

        self.selectedCategory = node.__selected__ ? node.id : undefined;
        var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.code;
            }).join(',');
            self.allFilters = [{ field: 'codeBrand', sign: 'IN', value: value }];
        } else {
            self.allFilters = false;
        }
        self.Filters();

        //self.update()
        //self.tags.catalog.reload()
    });
});

observable.on('warehouse-reload', function () {
    self.allFilters = [];
    self.update();
    self.getPurchases();
    self.tags.catalog.reload();
});

self.on('mount', function () {
    self.idManager = app.config.idUser;
    self.update();
});

/*
route('/orders/warehouse', () => {
    self.getPurchases()
    self.reload()
})

self.on('mount', () => {
    self.getPurchases()
    riot.route.exec()
})
*/
});


// WEBPACK FOOTER //
// ./pages/orders/warehouse-list.tag